var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoCuestionario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.68 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72b7a4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.58,57.91l-7.51-6.61c-.47-.42-1.08-.65-1.71-.65h-.16c-.69.05-1.33.36-1.78.88l-12.94,14.71-10.41,11.83-19.52,22.18-8.64,9.83-9.2,10.46-13.33,15.15-2.93,3.33-21.83-22.85c-1.32-1.39-3.5-1.5-4.96-.25l-9,7.71c-1.57,1.35-1.69,3.74-.26,5.24l29.27,30.57c1.77,1.94,4.3,3.05,6.93,3.05,2.76-.03,5.29-1.19,7.06-3.19l46.43-52.77,10.41-11.83,24.67-28.04c2.26-2.57,2.01-6.49-.56-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.58,180H23.61c-13.02,0-23.61-10.59-23.61-23.6V23.61C0,10.59,10.59,0,23.61,0h109.97c13.02,0,23.6,10.59,23.6,23.61v132.79c0,13.02-10.59,23.6-23.6,23.6ZM23.61,11.41c-6.72,0-12.19,5.47-12.19,12.19v132.79c0,6.72,5.47,12.19,12.19,12.19h109.97c6.72,0,12.19-5.47,12.19-12.19V23.61c0-6.72-5.47-12.19-12.19-12.19H23.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.24,40.9H30.86c-3.15,0-5.71-2.56-5.71-5.71s2.56-5.71,5.71-5.71h53.37c3.15,0,5.71,2.56,5.71,5.71s-2.56,5.71-5.71,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m124.79,66.71H30.86c-3.15,0-5.71-2.56-5.71-5.71s2.56-5.71,5.71-5.71h93.92c3.15,0,5.71,2.56,5.71,5.71s-2.56,5.71-5.71,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m124.79,95.71H30.86c-3.15,0-5.71-2.56-5.71-5.71s2.56-5.71,5.71-5.71h93.92c3.15,0,5.71,2.56,5.71,5.71s-2.56,5.71-5.71,5.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCuestionario);
export default __webpack_public_path__ + "static/media/IconoCuestionario.ab952bd3f1806c6d220be0c852de9083.svg";
export { ForwardRef as ReactComponent };